import { withInstall } from 'framework/utils'
import batchSearchInput from './src/BatchSearchInput.vue'
import { useComponentRegister } from 'framework/components/Form/index'
;[['BatchSearchInput', batchSearchInput]].forEach(([name, comp]) => {
  useComponentRegister(name as any, comp)
})

export const BatchSearchInput = withInstall(batchSearchInput)
